import { setDeviceChangeHistory } from "../../state/ducks";
import { dispatch } from "../../state/store";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = (endpoint, baseUrl = apiUrl) => {
  const url = `${baseUrl}/device-management/${endpoint}`;

  return url;
};

const fetchDeviceChangeHistory = async (dusn) => {
  const url = getRequestData(`get-device-change-history?deviceId=${dusn}`);

  const result = await httpClient.get(url);

  if (result?.data) {
    dispatch(setDeviceChangeHistory(result.data));
  }

  return result;
};

const createChangeHistoryRecord = async (dusns, action) => {
  const url = getRequestData("create-device-change-history");

  const data = {
    action,
    devices: dusns
  };

  const result = await httpClient.post(url, { data });

  return result;
};

const deviceChangeHistoryService = {
  fetchDeviceChangeHistory,
  createChangeHistoryRecord
};

export default deviceChangeHistoryService;
